export const isFilterUnchanged = <T>(applied: readonly T[] | undefined, selected: Iterable<T>) => {
    const appliedSet = new Set(applied);
    const selectedSet = new Set(selected);

    return appliedSet.size === selectedSet.size && [...selectedSet].every(item => appliedSet.has(item));
};
